const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

function formatDob(bYear, bMonth, bDay) {
  if (!bYear || !bMonth || !bDay) return "";
  const monthName = MONTHS[bMonth - 1];
  if (!monthName) return "";
  return `${monthName} ${bDay}, ${bYear}`;
}

function familyName(member) {
  const person = member?.user;
  if (person && typeof person === "object") {
    return (
      person.name ||
      `${person.first_name || ""} ${person.last_name || ""}`.trim() ||
      person.username ||
      member.name ||
      ""
    );
  }
  return member?.name || "";
}

export default function About({ profile }) {
  const details = profile?.details || {};
  const dob = formatDob(profile.bYear, profile.bMonth, profile.bDay);
  const family = (details.family || []).filter((member) => member?.user || member?.name);
  const bio = details.bio?.trim();
  const hobbies = details.hobbies || [];
  const featured = details.featured || [];

  return (
    <div className="profile_card about_card">
      <div className="profile_card_header">About</div>

      <div className="about_content">
        {bio && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="info_icon"></i>
              Bio
            </div>
            <div className="about_section_content">{bio}</div>
          </div>
        )}

        {details.job && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="work_icon"></i>
              Work
            </div>
            <div className="about_section_content">{details.job}</div>
          </div>
        )}

        {details.workplace && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="work_icon"></i>
              Workplace
            </div>
            <div className="about_section_content">{details.workplace}</div>
          </div>
        )}

        {details.highSchool && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="studies_icon"></i>
              High School
            </div>
            <div className="about_section_content">{details.highSchool}</div>
          </div>
        )}

        {details.college && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="studies_icon"></i>
              College
            </div>
            <div className="about_section_content">{details.college}</div>
          </div>
        )}

        {details.currentCity && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="home_icon"></i>
              Lives in
            </div>
            <div className="about_section_content">{details.currentCity}</div>
          </div>
        )}

        {details.hometown && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="home_icon"></i>
              From
            </div>
            <div className="about_section_content">{details.hometown}</div>
          </div>
        )}

        {dob && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="date_icon"></i>
              Birthday
            </div>
            <div className="about_section_content">{dob}</div>
          </div>
        )}

        {details.relationship && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="relationship_icon"></i>
              Relationship
            </div>
            <div className="about_section_content">{details.relationship}</div>
          </div>
        )}

        {family.length > 0 && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="relationship_icon"></i>
              Family
            </div>
            <div className="about_section_content">
              <div className="about_family_list">
                {family.map((member) => (
                  <div key={member.user?._id || familyName(member)} className="about_family_item">
                    <img
                      src={member.user?.picture || "/images/default_pic.png"}
                      alt=""
                      className="about_family_avatar"
                    />
                    <span>
                      {familyName(member)}
                      {member.relationship ? ` · ${member.relationship}` : ""}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {details.instagram && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="instagram_icon"></i>
              Instagram
            </div>
            <div className="about_section_content">
              <a
                href={`https://instagram.com/${details.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                @{details.instagram}
              </a>
            </div>
          </div>
        )}

        {hobbies.length > 0 && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="hobbies_icon"></i>
              Hobbies
            </div>
            <div className="about_section_content">
              <div className="hobbies_display_list">
                {hobbies.map((hobby, index) => (
                  <span key={index} className="hobby_display_tag">
                    {hobby}
                  </span>
                ))}
              </div>
            </div>
          </div>
        )}

        {featured.length > 0 && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="featured_icon"></i>
              Featured
            </div>
            <div className="about_section_content">
              <div className="featured_display_list">
                {featured.map((item, index) => (
                  <div key={index} className="featured_display_item">
                    <span className="featured_display_icon">
                      {item.type === "work"
                        ? "💼"
                        : item.type === "education"
                          ? "🎓"
                          : item.type === "achievement"
                            ? "🏆"
                            : item.type === "project"
                              ? "🚀"
                              : "⭐"}
                    </span>
                    <div className="featured_display_content">
                      <div className="featured_display_title">{item.title}</div>
                      {item.description && (
                        <div className="featured_display_description">{item.description}</div>
                      )}
                      {item.link && (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="featured_link"
                        >
                          View Link
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {profile.createdAt && (
          <div className="about_section">
            <div className="about_section_header">
              <i className="date_icon"></i>
              Joined
            </div>
            <div className="about_section_content">
              {new Date(profile.createdAt).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
